import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function NavigationPrevIcon(props) {
	return (
		<IconBase type="navigation-prev" {...props}>
			<path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" />
		</IconBase>
	);
}
NavigationPrevIcon.propTypes = iconPropTypes;
